module.exports = __webpack_public_path__ + "static/media/user-placeholder.3eaa8976.png";